/**
 * Gatsby browser APIs.
 *
 * Earlier builds shipped a service worker (gatsby-plugin-offline). Browsers
 * that still have it registered would keep serving stale pages after a deploy,
 * so unregister it on first load. `static/sw.js` is a self-destroying worker
 * that covers browsers checking for a worker update before this code runs.
 */
export const onClientEntry = () => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker
    .getRegistrations()
    .then(registrations =>
      registrations.forEach(registration => registration.unregister())
    )
    .catch(() => {});
};
